// userInputHandler.js
var UserInputHandler = pc.createScript('userInputHandler');

UserInputHandler.attributes.add('cam', {type: 'entity'});
UserInputHandler.attributes.add('target', {type: 'entity'});
UserInputHandler.attributes.add('addUI', {type: 'entity'});
UserInputHandler.attributes.add('infoText', {type: 'entity'});
UserInputHandler.attributes.add('buttonBar', {type: 'entity'});
UserInputHandler.attributes.add('buttons', {type:'entity', array:true});

UserInputHandler.attributes.add('uiCircle', {type:'entity'});
UserInputHandler.attributes.add('genButton', {type:'entity'});
UserInputHandler.attributes.add('inputField', {type:'entity'});
UserInputHandler.attributes.add('planetInfo', {type:'entity'});
UserInputHandler.attributes.add('planetNumber', {type:'entity'});
UserInputHandler.attributes.add('introScreen', {type:'entity'});

var that = this;

// initialize code called once per entity
UserInputHandler.prototype.initialize = function() {
     
    
    this.app.on('userInput:objectSelected', this.distribute, this);
    this.app.on('userInput:clickedPlus', this.clickedPlus, this);
    this.app.on('userInput:objectHovered', this.plusHovered, this);
    this.app.on('userInput:objectUnHovered', this.plusUnHovered, this);
    this.app.on('userInput:burger', this.burger, this);
    this.app.on('systemGenerator:reset', this.resetLastCollider, this);
    this.cameraScript = this.cam.script.orbitCamera;
    
    this.collectorButton = this.app.root.findByName('buttonAdUI9');

    this.planetInfo = this.app.root.findByName('planetInfo');
    this.planetInfoOn = false;
    this.currentPlanet = '';
    this.hoveredPlanet = null;
    this.burgerActive = false;
    this.physicalPlanet = null;

    this.solarScript = this.app.root.children[0].script.solarSystem;
    this.addUIscript = this.addUI.script.uiGenerator;
    this.resize = false;
    
    this.app.graphicsDevice.on('resizecanvas', function(width, height) {
        var ratio = width / height;
        if(that.contentVisible){
            that.resize = true;
        }

    });
 
    this.firstTime = true;
    this.inputPos = new pc.Vec3(this.genButton.getLocalPosition());
    this.genPos = new pc.Vec3(this.inputField.getLocalPosition());
    
    this.url = new URL(window.top.location.href);
    this.urlseed = this.url.searchParams.get('s');
    this.planetCamInd = this.url.searchParams.get('p');
    this.urlStart = false;
    
    if(this.urlseed !== null){
        this.urlStart = true;
        //this.orbitInit();
    }
    
    //this.infinityButton = this.app.root.findByName('infinityButton');
    this.planetInfo = this.app.root.findByName('planetInfo');
    this.planetNumber = this.app.root.findByName('planetNumberTag');
    this.input = this.app.root.findByName('input');
    this.genButton = this.app.root.findByName('generateButton');
    
    var cam = this.app.root.findByName('Camera');
    cam.children[0].model.model.meshInstances[0].material.opacity = 1;
    cam.children[0].model.model.meshInstances[0].material.update();
    this.fader(cam.children[0], 'down', 0.7);
        
    
};




UserInputHandler.prototype.distribute = function(ent){

    if(ent.name === 'habitable' || ent.name === 'system' || ent.name === 'rockPlanet' || ent.name === 'gasGiant'){
        this.physicalPlanet = ent;
        this.orbitTarget(ent);
    } else if(ent.name === 'plus'){
        this.clickedPlus(ent);
    }
    
};

UserInputHandler.prototype.clickedPlus = function (ent) {
    
    var scrpt = ent.parent.script.planetTagger;
    var plnt = scrpt.target;
    var typ = null;

    this.hoveredPlanet = plnt;

    if(plnt.script.planetGenerator){
        typ = plnt.script.planetGenerator.planetType;
    }
    if(plnt.script.gasGiant){
        typ = plnt.script.planetGenerator.planetType;
    }
    ent.enabled = false;
    ent.parent.children[0].enabled = true;

};


UserInputHandler.prototype.plusHovered = function (ent) {

    var scrpt = ent.parent.script.planetTagger;
    var plnt = scrpt.target;
    var typ = null;
    
    this.hoveredPlanet = plnt;
    
    if(this.currentPlanet == this.hoveredPlanet){
       // this.fadePlanetInfo('fadeIn');
    }
    if(plnt.children[1]){ 
        if(plnt.children[1].script.planetGenerator){
            typ = plnt.children[1].script.planetGenerator.planetType;
        }
        if(plnt.children[1].script.gasGiantGenerator){
            typ = plnt.children[1].script.gasGiantGenerator.planetType;
        }

    }
    
    if(this.currentPlanet.name === 'system'){
       // this.fadePlanetInfo('fadeIn');  
    }
    
    var tEnt = ent.parent.findByName('planetTag');
    tEnt.enabled = true;
    tEnt.children[1].element.text = typ;
};

UserInputHandler.prototype.plusUnHovered = function (ent) {
    var tEnt = ent.parent.findByName('planetTag');
    tEnt.enabled = false;
    if(this.currentPlanet == this.hoveredPlanet){
       // this.fadePlanetInfo('fadeOut');
    }
};

UserInputHandler.prototype.orbitTarget = function (ent) {
    this.planetInfoOn = true;
    this.currentPlanet = ent;
    if(this.currentPlanet !== null){
        that.app.fire('userInput:test', this.currentPlanet); // REQUESTING PLANET NAME!!!
    }
    
    this.app.on('specialLogos:checkVisible', this.checkVisibility, this);
    
    var newPos = ent.getPosition();

    var rstPnt = new pc.Vec3(newPos.x, newPos.y, newPos.z);

    this.cameraScript.resetAndLookAtPoint(this.cam.getLocalPosition(), newPos);
    this.addUIscript.thePlanet = this.currentPlanet;
    this.setMinMax(ent);

    this.app.fire('userInput:startOrbit', 'buttonAdUI0');
    this.hideShowButtons();
};

UserInputHandler.prototype.hideShowButtons = function(){
    if(this.currentPlanet.name == 'system'){
        for (var hd = 0; hd < this.buttons.length-2; hd++){
            this.buttons[hd].enabled = false;
        }
        this.collectorButton.enabled = false;
        this.buttons[5].enabled = true;
        var systm = this.physicalPlanet.children[this.physicalPlanet.children.length-1];
        if(systm.name == 'binary'){
            this.buttons[6].enabled = true;
        } else {
            this.buttons[6].enabled = false;
        }
    } else {
        this.collectorButton.enabled = true;
        for(var sh = 0; sh < this.buttons.length -1; sh++){
            this.buttons[sh].enabled = true;
            this.buttons[6].enabled = false;
            this.buttons[5].enabled = true;
        }
    }
    
};


UserInputHandler.prototype.fadePlanetInfo = function(dir) {
    if(this.planetInfoOn){
    var ent = this.planetInfo;
    var opac ={value:0};
    if(dir == 'fadeIn'){
        opac.value = 0;
            ent.tween(opac).to({value:1}, 1, pc.Linear).on('update', function(){
            ent.element.opacity = opac.value;
        }).start();
        
        this.planetInfoFirst = false;
    } else if(dir == 'fadeOut'){
        opac.value = 1;
            ent.tween(opac).to({value:0}, 1, pc.Linear).on('update', function(){
            ent.element.opacity = opac.value;
        }).start();
    }
}  
};

UserInputHandler.prototype.burger = function() {
    
    var tCam = this.app.root.findByName('Camera');
    var tRatio = this.app.root.children[0].script.responsiveHandler.ratio;
    var fadeObj = tCam.children[0];
    
    
    if(!this.burgerActive){
        this.fader(fadeObj, 'up', 0.3);
       
        
        this.planetInfo.enabled = false;
        this.planetNumber.enabled = false;
        this.genButton.enabled = false;
        this.input.enabled = false;
        
        tCam.script.orbitTouchInput.enabled = false;
        tCam.script.orbitMouseInput.enabled = false;
        this.app.fire('cameraController:orbitMouseTouchInput:stopInput');
        this.app.fire('cameraController:autoOrbit');
        //tCam.script.orbitCamera.enabled = false;
        this.burgerActive = true;
        
        if(tRatio > 1){
            
            this.infoText.parent.children[3].enabled = false;
            this.infoText.parent.children[4].enabled = true;
        } else {
            this.infoText.parent.children[3].enabled = true;
            this.infoText.parent.children[4].enabled = false;
        }
        
        
        this.buttonBar.enabled = false;
    } else if(this.burgerActive){
        this.fader(fadeObj, 'down', 0.3);

        this.planetInfo.enabled = true;
        this.planetNumber.enabled = true;
        this.genButton.enabled = true;
        this.input.enabled = true;
        
        this.app.fire('cameraController:orbitMouseTouchInput:startInput');
        tCam.script.orbitTouchInput.enabled = true;
        tCam.script.orbitMouseInput.enabled = true;
        //tCam.script.orbitCamera.enabled = true;
        this.burgerActive = false;
        this.infoText.parent.children[3].enabled = false;
        this.infoText.parent.children[4].enabled = false;
        this.buttonBar.enabled = true;
    }

};

UserInputHandler.prototype.fader = function(ent, dir, speed){
    
    var tMat = ent.model.model.meshInstances[0].material;
    var that = this;
    var from = 0;
    var to = 0;
    
    if(dir == 'up'){
        from = 0.0;
        to = 0.855;
    } else if(dir == 'down'){
        from = 0.855;
        to = 0.0;
    }
    
    var opac ={value:from};
    
    this.flashTween = ent
        .tween(opac)
        .to({value:to}, speed, pc.Linear)
        .on('update', function(){
            tMat.opacity = opac.value;
            tMat.update();
        })
        .on('complete', function(){
            if(that.entity.parent.enabled){

            } else {
              
            }
    })
        //.yoyo(true)
        //.repeat(2)
        .start();
    
};



UserInputHandler.prototype.setMinMax = function(obj){
        
    if(obj.name === 'system'){
        this.planetInfoOn = true;
        this.cameraScript.distanceMin = 1000;
        this.cameraScript.distanceMax = 2500;
    } else if(obj.name === 'rockPlanet'){
        this.cameraScript.distanceMin = 150;
        this.cameraScript.distanceMax = 200;
    } else if (obj.name === 'gasGiant'){
        this.cameraScript.distanceMin = 350;
        this.cameraScript.distanceMax = 600;
    } else if(obj.name === 'habitable'){
        this.cameraScript.distanceMin = 150
        ;
        this.cameraScript.distanceMax = 200;
    }
};

UserInputHandler.prototype.resetLastCollider = function () {
    //this.lastCollider = null;
};

// update code called every frame
UserInputHandler.prototype.update = function(dt) {
    
};

// swap method called for script hot-reloading
// inherit your script state here
// UserInputHandler.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// http://developer.playcanvas.com/en/user-manual/scripting/

